import React, { useContext } from 'react';
import { FormattedNumber } from 'react-intl';
import numeral from 'numeral';

import ProfileContext from 'contexts/ProfileContext';

const Currency = ({ amount, transaction_currency }: $TSFixMe) => {
  const { employee } = useContext(ProfileContext);
  const { currency = 'USD' } = employee.settings;
  const applicable_symbol = transaction_currency || currency;
  return (
    <FormattedNumber
      value={numeral(amount).value()}
      currency={applicable_symbol}
      {...{ style: 'currency' }}
    />
  );
};

export default Currency;
